import { RFS_URL } from 'config'
import { identity } from 'utils'
import { useRequest } from '../useRequest'

enum ApiPathname {
  CUSTOMER_IMAGES = '/cockpit/api/v1/customer-images/:customerId',
}

type GetCustomerImagesQuery = { customerId: string }
type GetCustomerImagesResponse = string[]

interface UseHookContext {
  getCustomerImages: (query: GetCustomerImagesQuery) => Promise<GetCustomerImagesResponse>
}

const baseUrl = new URL(RFS_URL)

const filterQueryToRouteParams = identity // Take all that is passed in and apply to route params

/**
 * Last remaining client for the Remote-Fitting-Service (RFS).
 *
 * The rest of RFS — fittings, fitting links, documents, active-fitting/tablet
 * reads — has been removed; the app now uses Room-Links and tablet-service. This
 * hook survives only because the Media tab's customer images
 * (`/cockpit/api/v1/customer-images`) have no replacement endpoint yet.
 *
 * @deprecated Retained solely for Media-tab customer images. Do not add new
 * callers or endpoints. Remove entirely once customer images are served from a
 * non-RFS source.
 */
const useRfsMedia = (): UseHookContext => {
  const getCustomerImages = useRequest<GetCustomerImagesQuery, GetCustomerImagesResponse>({
    baseUrl,
    filterQueryToRouteParams,
    pathname: ApiPathname.CUSTOMER_IMAGES,
  })

  return { getCustomerImages }
}

export { useRfsMedia }
